/**
 * Serialize a timestamp for persisted / serialized shapes.
 * Accepts `Date` or ISO strings: resource wire JSON often leaves dates as strings
 * even when TypeScript types them as `Date`.
 */
export function toIsoString(d: Date | string): string {
  if (d instanceof Date) {
    if (Number.isNaN(d.getTime())) {
      return new Date(0).toISOString();
    }
    return d.toISOString();
  }
  const parsed = new Date(d);
  if (Number.isNaN(parsed.getTime())) {
    return new Date(0).toISOString();
  }
  return parsed.toISOString();
}

export function fromIsoString(s: string): Date {
  return new Date(s);
}
